import CryptoJS from "crypto-js";

const secretKey =
    "e9NHdT3GU6wBdWlw3RTqvrShGzyerRl4BaMhFeUI3v4j6U0opW5a19HQHDAHHCrhYXq8oG6D";

// const apiKey = "https://skinapi.xyztown.info";
const apiKey = process.env.REACT_APP_API_URL;

async function fileToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(",")[1]);
        reader.onerror = (error) => reject(error);
    });
}

class UserService {
    static encryptData(data) {
        return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
    }

    static encryptEndpoint(endpoint) {
        return CryptoJS.AES.encrypt(endpoint, secretKey).toString();
    }

    static decryptData(encryptedData) {
        const secretKey =
            "e9NHdT3GU6wBdWlw3RTqvrShGzyerRl4BaMhFeUI3v4j6U0opW5a19HQHDAHHCrhYXq8oG6D";
        const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
        const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(decryptedData);
    }

    static async login(username, password) {
        const encryptedPayload = this.encryptData({
            action: "CHECK_SUSPEND_ACCOUNT",
            ARG: { username, password, agent: navigator.userAgent },
        });
        const encryptedEndpoint = this.encryptEndpoint("/ajax/test.php");
        // console.log("User agent:", navigator.userAgent);

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();
        return this.decryptData(responseData.data);
    }

    static async linkLogin(user_hash) {
        const encryptedPayload = this.encryptData({
            action: "LINK_LOGIN",
            ARG: { user_hash, agent: navigator.userAgent },
        });
        const encryptedEndpoint = this.encryptEndpoint("/ajax/test.php");

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();
        console.log(responseData);
        return this.decryptData(responseData.data);
    }

    static async loginWithToken(user_hash) {
        const encryptedPayload = this.encryptData({
            cmd: "login_m",
            val: user_hash,
        });
        const encryptedEndpoint = this.encryptEndpoint("/ajax/sendWS.php");

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();
        return this.decryptData(responseData.data);
    }

    static async depositAtm(user_hash, userid) {
        const encryptedPayload = this.encryptData({
            cmd: "depositatm",
            val: user_hash,
            userid: userid,
        });
        const encryptedEndpoint = this.encryptEndpoint("/ajax/sendWS.php");

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();
        console.log(this.decryptData(responseData.data));
        return this.decryptData(responseData.data);
    }

    static async getbalance(user_id, CURRENCY, version) {
        version = 2;
        const encryptedPayload = this.encryptData({
            action: "GET_PLAYER_BALANCE",
            ARG: { user_id, CURRENCY, version },
        });
        const encryptedEndpoint = this.encryptEndpoint("/ajax/test.php");

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();

        return this.decryptData(responseData.data);
    }

    static async suspend_account(user_id) {
        const encryptedPayload = this.encryptData({ user_id });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinApiV2/SUSPEND_ACCOUNT",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();

        return this.decryptData(responseData.data);
    }

    static async getTwoFQrCode(user_id) {
        const encryptedPayload = this.encryptData({ user_id });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinApiV2/GET_QR_CODE_2FA",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();

        return this.decryptData(responseData.data);
    }

    static async verifycode2fa(user_id, code) {
        const encryptedPayload = this.encryptData({ user_id, code });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinApiV2/VERIFY_CODE_2FA",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();

        return this.decryptData(responseData.data);
    }

    static async verifycode2fa_skin(user_id, code) {
        const encryptedPayload = this.encryptData({ user_id, code });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinApiV2/VERIFY_CODE_2FA_SKIN",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();

        return this.decryptData(responseData.data);
    }

    static async verifycodeandenable2fa(user_id, code) {
        const encryptedPayload = this.encryptData({ user_id, code });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinApiV2/VERIFY_CODE_2FA_AND_ENABLE_2FA",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();

        return this.decryptData(responseData.data);
    }

    static async enable2fa(user_id) {
        const encryptedPayload = this.encryptData({ user_id });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinApiV2/ENABLE_TWOFA",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();

        return this.decryptData(responseData.data);
    }

    static async isget2fa(user_id) {
        const encryptedPayload = this.encryptData({ user_id });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinApiV2/GET_USER_2FA",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();

        return this.decryptData(responseData.data);
    }

    static async getEnabledArea(user_id) {
        const encryptedPayload = this.encryptData({ user_id });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinApiV2/GET_ENABLED_AREA",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();

        return responseData.data;
    }

    static async getAvailableArea(user_id) {
        const encryptedPayload = this.encryptData({
            action: "GET_AVAILABLE_AREA",
            ARG: { user_id },
        });
        const encryptedEndpoint = this.encryptEndpoint("/ajax/test.php");

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();

        return this.decryptData(responseData.data);
    }

    static async getTransferArea(user_id) {
        const encryptedPayload = this.encryptData({ user_id });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinApiV2/GET_TRANSFER_AREA",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();

        return responseData.data;
    }

    static async getCurList(user_id) {
        const encryptedPayload = this.encryptData({ user_id });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinApiV2/GET_SKIN_CURRENCY_LIST",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();

        return this.decryptData(responseData.data);
    }

    static async getCupon(
        USER_ID,
        CURRENCY,
        STATUS,
        START_DATE,
        END_DATE,
        PAGE,
        LIMIT,
    ) {
        const encryptedPayload = this.encryptData({
            action: "GET_COUPON",
            ARG: {
                USER_ID,
                CURRENCY,
                STATUS,
                START_DATE,
                END_DATE,
                PAGE,
                LIMIT,
            },
        });
        const encryptedEndpoint = this.encryptEndpoint("/ajax/test.php");

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();

        return this.decryptData(responseData.data);
    }

    static async getBet(
        USER_ID,
        CURRENCY,
        TIPE_OF_TRANSACTION,
        START_DATE,
        END_DATE,
        PAGE,
        LIMIT,
    ) {
        const encryptedPayload = this.encryptData({
            action: "GET_CASINO_HISTORY",
            ARG: {
                USER_ID,
                CURRENCY,
                TIPE_OF_TRANSACTION,
                START_DATE,
                END_DATE,
                PAGE,
                LIMIT,
            },
        });
        const encryptedEndpoint = this.encryptEndpoint("/ajax/test.php");

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();

        return this.decryptData(responseData.data);
    }

    static async getDocuments(USER_ID) {
        const encryptedPayload = this.encryptData({ USER_ID });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinApiV2/CHECK_USER_DOCUMENT_UPLOD_USERS",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();

        return this.decryptData(responseData.data);
    }

    static async saveDocuments(user_id, documentData, adminPanel) {
        const formData = new FormData();
        formData.append("user_id", user_id);
        formData.append("DOCUMENT_UPLOAD_TYPE", documentData.type);
        formData.append("DOCUMENT_NUMBER", documentData.number);
        formData.append("admin_panel", adminPanel);

        if (documentData.front)
            formData.append("DOCUMENT_FRONT", documentData.front);
        if (documentData.back)
            formData.append("DOCUMENT_BACK", documentData.back);
        if (documentData.fiscalCode)
            formData.append("DOCUMENT_CODICE_FS", documentData.fiscalCode);

        const encryptedEndpoint = this.encryptEndpoint(
            "/FileUploader/uploadDocuments",
        );

        const response = await fetch(
            `https://api.gamesolutions.org/FileUploader/uploadDocuments`,
            {
                method: "PUT",
                body: formData,
            },
        );

        const responseData = await response.json();
        return responseData;
    }

    static async getMobile(USER_ID) {
        const encryptedPayload = this.encryptData({ USER_ID });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinApiV2/GET_USER_MOBILE",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();

        return this.decryptData(responseData.data);
    }

    static async getAllCode(USER_ID) {
        const encryptedPayload = this.encryptData({ USER_ID });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinApiV2/GET_ALL__MOBILE_CODE",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();

        return this.decryptData(responseData.data);
    }

    static async updateMobile(USER_ID, mobile, country_code) {
        const encryptedPayload = this.encryptData({
            USER_ID,
            mobile,
            country_code,
        });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinApiV2/UPDATE_USER_MOBILE",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();

        return this.decryptData(responseData.data);
    }

    static async updatePassword(USER_ID, currentpassword, newpassword) {
        const encryptedPayload = this.encryptData({
            USER_ID,
            currentpassword,
            newpassword,
        });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinApiV2/UPDATE_USER_PASSWORD",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();

        return this.decryptData(responseData.data);
    }

    static async getPrivacy(USER_ID) {
        const encryptedPayload = this.encryptData({ USER_ID });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinApiV2/GET_PRIVACY_STATUS",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();

        return this.decryptData(responseData.data);
    }

    static async updatePrivacyStatus(USER_ID, privacyStatus) {
        const encryptedPayload = this.encryptData({
            USER_ID,
            ...privacyStatus,
        });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinApiV2/UPDATE_PRIVACY_STATUS",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();
        return this.decryptData(responseData.data);
    }

    static async getUserLimit(USER_ID) {
        const encryptedPayload = this.encryptData({ USER_ID });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinApiV2/GET_DEPOSIT_STATUS",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();
        return this.decryptData(responseData.data);
    }

    static async getUser2ffa(USER_ID) {
        const encryptedPayload = this.encryptData({ USER_ID });
        const encryptedEndpoint = this.encryptEndpoint("/SkinApiV2/GET_2FFA");

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();
        return this.decryptData(responseData.data);
    }

    static async updateUserLimit(
        USER_ID,
        limit_deposit_status,
        limit_deposit_value,
    ) {
        const encryptedPayload = this.encryptData({
            USER_ID,
            limit_deposit_status,
            limit_deposit_value,
        });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinApiV2/UPDATE_DEPOSIT_STATUS",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();
        return this.decryptData(responseData.data);
    }

    static async getLoginHistory(USER_ID, LIMIT, PAGE) {
        const encryptedPayload = this.encryptData({
            action: "GET_LOGIN",
            ARG: { USER_ID, LIMIT, PAGE },
        });

        const encryptedEndpoint = this.encryptEndpoint("/ajax/test.php");

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();
        return this.decryptData(responseData.data);
    }

    static async getCashMovement(
        USER_ID,
        CURRENCY,
        TIPE_OF_TRANSACTION,
        START_DATE,
        END_DATE,
        PAGE,
        LIMIT,
    ) {
        const encryptedPayload = this.encryptData({
            action: "GET_TRANSACTION_HISTORY",
            ARG: {
                USER_ID,
                CURRENCY,
                TIPE_OF_TRANSACTION,
                START_DATE,
                END_DATE,
                PAGE,
                LIMIT,
            },
        });
        const encryptedEndpoint = this.encryptEndpoint("/ajax/test.php");

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();
        return this.decryptData(responseData.data);
    }

    static async getDepositMethod(CURRENCY) {
        const encryptedPayload = this.encryptData({
            ARG: { CURRENCY: CURRENCY },
        });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinsController/GET_DEPOSIT_METHOD",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();
        return this.decryptData(responseData.data);
    }

    static async getWithdrawMethod(CURRENCY) {
        const encryptedPayload = this.encryptData({
            ARG: { CURRENCY: CURRENCY },
        });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinsController/GET_WITHDRAW_METHOD",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();
        return this.decryptData(responseData.data);
    }

    static async getMessage(
        USER_ID,
        MESSAGE_ID,
        STATUS,
        START_DATE,
        END_DATE,
        PAGE,
        LIMIT,
    ) {
        const encryptedPayload = this.encryptData({
            action: "GET_MESSAGE",
            ARG: {
                USER_ID,
                MESSAGE_ID,
                STATUS,
                START_DATE,
                END_DATE,
                PAGE,
                LIMIT,
            },
        });
        const encryptedEndpoint = this.encryptEndpoint("/ajax/test.php");

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();
        return this.decryptData(responseData.data);
    }

    static async sendReset(email) {
        const encryptedPayload = this.encryptData({ email, email });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinApiV2/SEND_EMAIL_RESET_BY_EMAIL",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();
        return this.decryptData(responseData.data);
    }

    static async checkCodePass(code) {
        const encryptedPayload = this.encryptData({ code, code });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinApiV2/CHECK_CODE_RESET",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();
        return this.decryptData(responseData.data);
    }

    static async changePass(code, password) {
        const encryptedPayload = this.encryptData({
            code,
            code,
            password: password,
        });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinApiV2/CHANGE_PASS",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();
        return this.decryptData(responseData.data);
    }

    static async createUser(
        email,
        password,
        name,
        lastname,
        firstname,
        document_type,
        document_number,
        mobile,
        birthday,
        currency,
        agent_id,
    ) {
        const encryptedPayload = this.encryptData({
            email,
            password,
            name,
            lastname,
            firstname,
            document_type,
            document_number,
            mobile,
            birthday,
            currency,
            agent_id,
        });
        const encryptedEndpoint = this.encryptEndpoint(
            "/SkinApiV2/CREATE_USER_PROFILE",
        );

        const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedPayload,
                endpoint: encryptedEndpoint,
            }),
        });

        const responseData = await response.json();
        return this.decryptData(responseData.data);
    }

    static async getUserIP() {
        try {
            const response = await fetch("https://api.ipify.org?format=json");
            const data = await response.json();
            return data.ip;
        } catch (error) {
            console.error("Error fetching user IP:", error);
            return null;
        }
    }

    static async getGeoBlock() {
        try {
            const userIP = await UserService.getUserIP();

            const encryptedPayload = this.encryptData({ ip: userIP });
            const encryptedEndpoint = this.encryptEndpoint(
                "/SkinApiV2/GET_GEO_BLOCK",
            );

            const response = await fetch(`${apiKey}${encryptedEndpoint}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    data: encryptedPayload,
                    endpoint: encryptedEndpoint,
                }),
            });

            const responseData = await response.json();
            // console.log(this.decryptData(responseData.data));
            return this.decryptData(responseData.data);
        } catch (error) {
            console.error("Error fetching geo block:", error);
            return { status: false, data: "Error fetching geo block" };
        }
    }
}

export default UserService;
